// src/utils/clone.js
export function safeClone(value) {
  // Попытка native structuredClone (быстрее и лучше, если сработает)
  if (typeof structuredClone === 'function') {
    try {
      return structuredClone(value);
    } catch (e) {
      // fallthrough -> используем запасной клонировщик
    }
  }

  const seen = new WeakMap();

  function isPlainObject(val) {
    return Object.prototype.toString.call(val) === '[object Object]';
  }

  function isNode(val) {
    return (typeof Node !== 'undefined' && val instanceof Node) || false;
  }

  function cloneRec(val) {
    if (val === null || typeof val !== 'object') return val;

    if (typeof val === 'function') return undefined;
    if (isNode(val)) return undefined;
    if (val instanceof Error) {
      return { name: val.name, message: val.message, stack: val.stack };
    }
    if (val instanceof Date) return new Date(val.getTime());
    if (val instanceof RegExp) return new RegExp(val.source, val.flags);

    if (ArrayBuffer.isView(val)) {
      try {
        return val.slice ? val.slice() : new val.constructor(val);
      } catch {
        return undefined;
      }
    }
    if (val instanceof ArrayBuffer) {
      return val.slice(0);
    }

    if (val instanceof Map) {
      if (seen.has(val)) return seen.get(val);
      const res = new Map();
      seen.set(val, res);
      for (const [k, v] of val.entries()) res.set(cloneRec(k), cloneRec(v));
      return res;
    }
    if (val instanceof Set) {
      if (seen.has(val)) return seen.get(val);
      const res = new Set();
      seen.set(val, res);
      for (const v of val.values()) res.add(cloneRec(v));
      return res;
    }

    if (Array.isArray(val)) {
      if (seen.has(val)) return seen.get(val);
      const arr = [];
      seen.set(val, arr);
      for (let i = 0; i < val.length; i++) arr[i] = cloneRec(val[i]);
      return arr;
    }

    if (isPlainObject(val) || Object.getPrototypeOf(val) === Object.prototype) {
      if (seen.has(val)) return seen.get(val);
      const out = {};
      seen.set(val, out);
      for (const key of Object.keys(val)) {
        try {
          const cloned = cloneRec(val[key]);
          if (cloned !== undefined) out[key] = cloned;
        } catch {}
      }
      return out;
    }

    try {
      if (seen.has(val)) return seen.get(val);
      const proto = Object.getPrototypeOf(val);
      const out = Object.create(proto);
      seen.set(val, out);
      for (const key of Object.keys(val)) {
        try {
          const cloned = cloneRec(val[key]);
          if (cloned !== undefined) out[key] = cloned;
        } catch {}
      }
      return out;
    } catch {
      return undefined;
    }
  }

  return cloneRec(value);
}


export const safeRead = (key, fallback) => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      const raw = localStorage.getItem(key)
      return raw ? JSON.parse(raw) : fallback
    }
  } catch (e) {
    console.warn('Ошибка чтения localStorage:', e)
  }
  return fallback
}

export const safeWrite = (key, data) => {
  try {
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.setItem(key, JSON.stringify(data))
    }
  } catch (e) {
    console.warn('Ошибка записи localStorage:', e)
  }
}